<template>
  <div class="dark:bg-dark-2 light:bg-light-1 h-58 text-white relative overflow-hidden">
    <div class="flex flex-col md:flex-row h-full">
      <div class="h-1/2 z-10 w-full px-1/10 py-5 gap-5 md:(w-1/2 h-full) flex items-center justify-center lg:gap-8">
        <template v-for="bank in banks">
          <div class="flex items-center justify-center">
            <img
              :src="bank"
              :width="$q.screen.gt.sm ? '40' : '24'"
            >
          </div>
        </template>
      </div>
      <div class="h-1/2 z-10 backdrop-blur w-full flex flex-col items-center py-5 gap-2 md:(w-1/2 h-full px-12 py-10 gap-5 items-start)">
        <div class="text-center md:(text-xl text-left) font-bold dark:text-white light:text-light-text ">
          <div>빠르고 안전하게 시작하세요!</div>
          <div>회원별 가상계좌 서비스 도입</div>
        </div>
        <QBtn
          :to="{ name: 'questions' }"
          unelevated
          label="입금"
          class="bg-gradient-primary h-10 w-25 md:(h-14 w-35) text-sm font-bold"
        />
      </div>
    </div>
    <div class="absolute z-1 top-8 md:(-bottom-12 -left-14)">
      <img
        :src="$q.dark.isActive? ball1 :lightBall1"
        :width="$q.screen.gt.sm ? '260' : '100'"
      >
    </div>
    <div class="absolute z-1 bottom-10 -right-8 md:(left-2/5 bottom-10)">
      <img
        :src="$q.dark.isActive? ball2 :lightBall2"
        :width="$q.screen.gt.sm ? '300' : '150'"
      >
    </div>
  </div>
</template>

<script setup>
import ball1 from '@/assets/home/banks/ball-1.png'
import lightBall1 from '@/assets/home/banks/light-ball-1.png'
import ball2 from '@/assets/home/banks/ball-2.png'
import lightBall2 from '@/assets/home/banks/light-ball-2.png'
import bank1 from '@/assets/home/banks/bank-1.png'
import bank2 from '@/assets/home/banks/bank-2.png'
import bank3 from '@/assets/home/banks/bank-3.png'
import bank4 from '@/assets/home/banks/bank-4.png'
import bank5 from '@/assets/home/banks/bank-5.png'
import bank6 from '@/assets/home/banks/bank-6.png'
import bank7 from '@/assets/home/banks/bank-7.png'
import bank8 from '@/assets/home/banks/bank-8.png'
import bank9 from '@/assets/home/banks/bank-9.png'

const banks = [
  bank1,
  bank2,
  bank3,
  bank4,
  bank5,
  bank6,
  bank7,
  bank8,
  bank9,
]
</script>
